$(document).ready(function() {
	if ($(".calendar").length > 0) {
		let events = {};
		
		// Funzione per aggiungere il pallino blu ai giorni con eventi
		function addEventDots () {
			$(".event-day").each(function() {
				if ($(this).find(".dot").length === 0) {
					$(this).append('<div class="dot"></div>');
				}
			});
		}
		
		// Funzione per forzare la selezione visiva sui calendari
		function updateActiveDay () {
			$(".calendar").each(function() {
				let selectedDate = $(this).datepicker("getDate");
				let formattedDate = $.datepicker.formatDate("d", selectedDate);
				
				$(this)
					.find(".ui-datepicker-calendar td")
					.each(function() {
						let day = $(this).text().trim();
						if (day === formattedDate) {
							$(this).addClass("ui-state-active");
						} else {
							$(this).removeClass("ui-state-active");
						}
					});
			});
		}
		
		// Funzione per caricare gli eventi per una data specifica
		function loadEventsForDate (dateText) {
			$("#events-top, #events").fadeOut(500, function() {
				// Svuota i contenitori dopo il fadeOut
				$("#events-top").html("");
				$("#events").html("");
			});
			
			$.ajax({
				type: "POST",
				url: `${URL}/it/ajax/site/getEventiAjax/`,
				data: { date: dateText, all: false },
				dataType: "json",
				success: function(data) {
					let eventsHtml = "<ul>";
					let eventsHtmlTop = "<ul>";
					
					if (data.result && data.result.length > 0) {
						for (let event of data.result) {
							let dataEventoFormattata = event.data_evento_formattata;
							let dataFineEventoFormattata = event.data_fine_evento_formattata;
							
							let dataVisualizzata =
								event.data_evento === event.data_fine_evento ?
								`${dataEventoFormattata} - ${event.data_fine_evento_orario}` :
								`${dataEventoFormattata} - ${dataFineEventoFormattata}`;
							
							eventsHtml += `
																<li style="border: 1px solid ${event.colore};">
																		<p class="mb-2">
																				<a href="${APP}/eventi-in-citta/">Eventi</a> ::
																				<a style="color: ${event.colore};" href="${APP}/eventi-in-citta/categoria/${
								event.slug_cat
							}/">${event.sottocategoria_evento_label}</a>
																		</p>
																		<h6 class="title m-0">
																				<a href="${APP}/evento/${event.slug}/">${event.titolo}</a>
																		</h6>
																		<p class="m-0">
																				<a href="${APP}/evento/${event.slug}/">${event.breve}</a><br>
																				<strong>Data:</strong> ${dataVisualizzata}<br>
																				${
																					event.dove
																						? `<strong>Luogo: </strong><a href="${APP}/sito-turistico/${event.dove_slug}/">${event.dove}</a>`
																						: ""
																				}
																		</p>
																</li>
														`;
							
							eventsHtmlTop += `
																<li style="border: 1px solid ${event.colore};">
																		<p class="mb-2">
																				<a href="${APP}/eventi-in-citta/">Eventi</a> ::
																				<a style="color: ${event.colore};" href="${APP}/eventi-in-citta/categoria/${event.slug_cat}/">${event.sottocategoria_evento_label}</a>
																				<br>	<span class="fs-6">${dataVisualizzata}</span>
																		</p>
																	
																		<h6 class="title m-0">
																				<a href="${APP}/evento/${event.slug}/">${event.titolo}</a>
																		</h6>
																</li>
														`;
						}
					} else {
						eventsHtml += "<li>Nessun evento per questa data</li>";
						eventsHtmlTop += "<li>Nessun evento per questa data</li>";
					}
					eventsHtml += "</ul>";
					eventsHtmlTop += "</ul>";
					
					$("#events").html(eventsHtml);
					$("#events-top").html(eventsHtmlTop);
					
					$("#events-top, #events").fadeIn(500, function() {});
				},
			});
		}
		
		// Chiamata iniziale per ottenere tutti gli eventi
		$.ajax({
			type: "POST",
			url: `${URL}/it/ajax/site/getEventiAjax/`,
			data: { all: true },
			dataType: "json",
			success: function(data) {
				if (data.result && data.result.length > 0) {
					for (let event of data.result) {
						let startDate = new Date(event.data_evento.split(" ")[0]);
						let endDate = new Date(event.data_fine_evento.split(" ")[0]);
						
						// Itera attraverso tutte le date tra startDate ed endDate
						while (startDate <= endDate) {
							let eventDate = $.datepicker.formatDate("yy-mm-dd", startDate);
							if (!events[eventDate]) {
								events[eventDate] = [];
							}
							events[eventDate].push(event);
							
							// Incrementa la data di un giorno
							startDate.setDate(startDate.getDate() + 1);
						}
					}
				}
				
				// Configurazione del Datepicker
				$(".calendar").datepicker({
					beforeShowDay: function(date) {
						let dateString = $.datepicker.formatDate("yy-mm-dd", date);
						return events[dateString] ?
							[true, "event-day", ""] :
							[true, "", ""];
					},
					onSelect: function(dateText) {
						$(".calendar").each(function() {
							$(this).datepicker("setDate", dateText);
						});
						setTimeout(updateActiveDay, 10);
						loadEventsForDate(dateText);
					},
				});
				
				// Seleziona la data di oggi su tutti i calendari
				let today = $.datepicker.formatDate("yy-mm-dd", new Date());
				$(".calendar").each(function() {
					$(this).datepicker("setDate", today);
				});
				
				setTimeout(updateActiveDay, 10);
				loadEventsForDate(today);
				addEventDots();
			},
		});
		
		// Impostazione del calendario in italiano
		$.datepicker.setDefaults({
			closeText: "Chiudi",
			prevText: "&#x3C;Prec",
			nextText: "Succ&#x3E;",
			currentText: "Oggi",
			monthNames: [
				"Gennaio",
				"Febbraio",
				"Marzo",
				"Aprile",
				"Maggio",
				"Giugno",
				"Luglio",
				"Agosto",
				"Settembre",
				"Ottobre",
				"Novembre",
				"Dicembre",
			],
			monthNamesShort: [
				"Gen",
				"Feb",
				"Mar",
				"Apr",
				"Mag",
				"Giu",
				"Lug",
				"Ago",
				"Set",
				"Ott",
				"Nov",
				"Dic",
			],
			dayNames: [
				"Domenica",
				"Lunedì",
				"Martedì",
				"Mercoledì",
				"Giovedì",
				"Venerdì",
				"Sabato",
			],
			dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
			dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
			weekHeader: "Sm",
			dateFormat: "yy-mm-dd",
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: "",
		});
	}
});